export default __webpack_public_path__ + "static/char-09-anr-b667a565910b4b323c49b38fa7dcf9d7.webp";